<template>
  <layout-no-menu>
    <ion-header>
      <ion-toolbar color="primary">
        <ion-title>Payment</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <ion-item lines="none">
        <ion-label class="ion-text-center">
          <h1 v-if="status === 'Paid'">Payment complete</h1>
          <h1 v-else-if="isFinal">Payment not completed</h1>
          <h1 v-else>Confirming your payment…</h1>
        </ion-label>
      </ion-item>

      <div v-if="!isFinal && !error" class="ion-text-center ion-padding">
        <ion-spinner name="crescent"></ion-spinner>
        <p>This usually takes a few seconds. Please keep this page open.</p>
      </div>

      <template v-if="order && status === 'Paid'">
        <ion-list>
          <ion-item v-for="item in order.items" :key="item.playerId">
            <ion-icon slot="start" name="checkmark" color="success"></ion-icon>
            <ion-label>{{ item.description }}</ion-label>
            <ion-note slot="end">{{ money(item.amountCents) }}</ion-note>
          </ion-item>
          <ion-item lines="none">
            <ion-label><strong>Total paid</strong></ion-label>
            <ion-note slot="end" color="dark"><strong>{{ money(order.amountCents) }}</strong></ion-note>
          </ion-item>
        </ion-list>
        <ion-item lines="none">
          <ion-label text-wrap>
            <p>Order #{{ order.id }} · paid via {{ order.provider }}. A receipt was emailed to {{ order.buyerEmail }}.</p>
          </ion-label>
        </ion-item>
      </template>

      <ion-item v-if="isFinal && status !== 'Paid'" lines="none">
        <ion-label text-wrap>
          <p v-if="status === 'Expired'">The checkout session expired before payment was completed.</p>
          <p v-else-if="status === 'Failed'">The payment could not be started.</p>
          <p v-else>The payment was not completed.</p>
          <p>No charge was made for order #{{ orderId }}. You can try again.</p>
        </ion-label>
      </ion-item>

      <ion-item v-if="timedOut" lines="none">
        <ion-label text-wrap color="warning">
          <p>We have not received confirmation yet. If your card was charged, your registration will update automatically within a few minutes. Otherwise, try again.</p>
        </ion-label>
      </ion-item>

      <ion-item v-if="error" lines="none">
        <ion-label text-wrap color="danger"><p>{{ error }}</p></ion-label>
      </ion-item>

      <div class="ion-padding-horizontal ion-margin-top">
        <ion-button v-if="status === 'Paid'" expand="block" @click="goToTournament">Back to tournament</ion-button>
        <ion-button v-if="isFinal && status !== 'Paid'" expand="block" @click="tryAgain">Try again</ion-button>
        <ion-button v-if="timedOut" expand="block" fill="outline" @click="checkNow">Check again</ion-button>
        <ion-button v-if="status !== 'Paid'" expand="block" fill="clear" @click="goToTournament">Back to tournament</ion-button>
      </div>
      <div style="height:120px"></div>
    </ion-content>
  </layout-no-menu>
</template>

<script>
import PaymentAPI from "@/services/PaymentAPI";
const paymentAPI = new PaymentAPI();

const POLL_MS = 2000;
const VERIFY_AFTER_MS = 10000;
const GIVE_UP_AFTER_MS = 60000;

export default {
  name: "PaymentComplete",
  data() {
    return {
      tournamentId: this.$route.params.tournament,
      orderId: parseInt(this.$route.query.order),
      orderKey: this.$route.query.key || "",
      order: null,
      error: "",
      timedOut: false,
      verified: false,
      startedAt: Date.now(),
      timer: null,
    };
  },
  computed: {
    status() {
      return this.order ? this.order.status : null;
    },
    isFinal() {
      return ["Paid", "Expired", "Failed", "Refunded", "PartiallyRefunded"].includes(this.status);
    },
  },
  methods: {
    money(cents) {
      return PaymentAPI.money(cents, this.order ? this.order.currency : "USD");
    },
    goToTournament() {
      this.$router.push({ name: "Tournament", params: { tournament: this.tournamentId } });
    },
    tryAgain() {
      if (this.$route.query.invoice === "1") {
        this.$router.push({ name: "Invoice", params: { tournament: this.tournamentId, id: this.orderId }, query: { key: this.orderKey } });
        return;
      }
      this.$router.push({ name: this.orderKey ? "Pay" : "Payment", params: { tournament: this.tournamentId } });
    },
    stop() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    },
    schedule() {
      this.stop();
      this.timer = setTimeout(() => this.poll(), POLL_MS);
    },
    async checkNow() {
      this.timedOut = false;
      this.startedAt = Date.now();
      this.verified = false;
      await this.poll();
    },
    async poll() {
      if (!this.orderId) {
        this.error = "Missing order id.";
        return;
      }
      try {
        const elapsed = Date.now() - this.startedAt;
        if (!this.verified && elapsed >= VERIFY_AFTER_MS) {
          // Webhook may be slow; ask the server to confirm directly with the provider once.
          this.verified = true;
          this.order = await paymentAPI.verify(this.orderId, this.orderKey);
        } else {
          this.order = await paymentAPI.order(this.orderId, this.orderKey);
        }
        this.error = "";
        if (this.isFinal) {
          this.stop();
          return;
        }
        if (elapsed >= GIVE_UP_AFTER_MS) {
          this.timedOut = true;
          this.stop();
          return;
        }
        this.schedule();
      } catch (e) {
        this.error = typeof e === "string" ? e : "Could not load the order.";
        this.stop();
      }
    },
  },
  created() {
    this.poll();
  },
  beforeDestroy() {
    this.stop();
  },
};
</script>
